/**
 * Zwei Stammsätze zu einem verschmelzen.
 *
 * Nötig, seit Plätze beiläufig entstehen — beim Erfassen (Teilprojekt 2) und
 * beim Bearbeiten einer Zelle (3a). "Blue Hole" und "Blue Hole (Dahab)" sind
 * dann zwei Sätze.
 */

import { SPEICHER, alleTauchgaenge } from './db.js';
import { loesche, speichere } from './saetze.js';

/** Welches Feld im Tauchgang auf diese Art zeigt. */
const VERWEIS = {
  sites: { id: 'site_id', name: 'site_name' },
  trips: { id: 'trip_id', name: 'trip_name' },
};

const leer = (wert) => wert === null || wert === undefined || wert === '';

/**
 * Der bleibende Satz behält seine Werte; wo er nichts hat, kommt der andere.
 *
 * Damit gehen Koordinaten oder eine Notiz nicht verloren, die nur am
 * weichenden Satz hingen — der häufige Fall beim Aufräumen.
 */
export function fuelleLuecken(bleibt, weicht) {
  const ergebnis = { ...bleibt };
  for (const [schluessel, wert] of Object.entries(weicht)) {
    if (schluessel === 'id') continue;
    if (leer(ergebnis[schluessel]) && !leer(wert)) ergebnis[schluessel] = wert;
  }
  return ergebnis;
}

/**
 * Zusammenführen in drei Schritten: auffüllen, umhängen, löschen.
 *
 * Die Reihenfolge ist nicht beliebig. Bräche es nach dem Umhängen ab, stünden
 * zwei Sätze da, von denen einer keine Tauchgänge mehr hat — harmlos und beim
 * zweiten Anlauf zu Ende zu bringen. Umgekehrt hätte man Tauchgänge, die auf
 * einen gelöschten Platz zeigen.
 */
export async function fuehreZusammen(db, art, bleibt, weicht, optionen = {}) {
  const verweis = VERWEIS[art];
  if (!verweis) throw new Error(`Zusammenführen ist für ${art} nicht vorgesehen.`);
  if (bleibt.id === weicht.id) throw new Error('Das ist derselbe Satz.');

  await speichere(db, SPEICHER[art], fuelleLuecken(bleibt, weicht), optionen);

  const betroffen = (await alleTauchgaenge(db))
    .filter((tg) => tg[verweis.id] === weicht.id)
    .map((tg) => ({ ...tg, [verweis.id]: bleibt.id, [verweis.name]: bleibt.name }));
  if (betroffen.length) await speichere(db, SPEICHER.dives, betroffen, optionen);

  await loesche(db, SPEICHER[art], [weicht.id]);
  return { umgehaengt: betroffen.length };
}
